























import Vue from "vue";
import { Option } from "@/types";

export default Vue.extend({
  props: {
    option: {
      type: Object as () => Option,
      required: true
    }
  },
  methods: {
    handleSetSelectedOption(option: Option) {
      this.$emit("set-selected-option", option);
    }
  }
});
